(function () {
  // Script for stacking Bootstrap 4 modals.
  // Formula: backdrop z-index = 1040 + 1 * i, modal z-index = 1041 + 1 * i.
  // This ensures that the backdrop always covers the modals as required.

  const Z_INDEX = {
    BACKDROP_BASE: 1040,
    MODAL_BASE: 1041,
    STEP: 1,
  };

  /**
   * Updates the z-index for all visible modals and their backdrops.
   */
  const updateStack = () => {
    const $shownModals = $('.modal.show');
    $shownModals.each((index, modal) => {
      const zIndex = Z_INDEX.MODAL_BASE + Z_INDEX.STEP * index;
      $(modal).css('z-index', zIndex);
    });

    $('.modal-backdrop').each((index, backdrop) => {
      const zIndex = Z_INDEX.BACKDROP_BASE + Z_INDEX.STEP * index;
      $(backdrop).css('z-index', zIndex);
    });
  };

  /**
   * Event handler for showing a modal.
   */
  const onModalShow = () => {
    setTimeout(() => {
      const $shownModals = $('.modal.show');
      const topModalIndex = Math.max($shownModals.length - 1, 0);

      const modalZIndex = Z_INDEX.MODAL_BASE + Z_INDEX.STEP * topModalIndex;
      const backdropZIndex = Z_INDEX.BACKDROP_BASE + Z_INDEX.STEP * topModalIndex;

      // Set z-index for the top modal
      $shownModals.last().css('z-index', modalZIndex);

      // Set z-index for the last backdrop
      const $lastBackdrop = $('.modal-backdrop').not('.modal-stack').last();
      if ($lastBackdrop.length) {
        $lastBackdrop.css('z-index', backdropZIndex).addClass('modal-stack');
      }

      updateStack();
    }, 0);
  };

  /**
   * Event handler for hiding a modal.
   */
  const onModalHidden = () => {
    setTimeout(updateStack, 0);
  };

  // Attach event handlers
  $(document).on('show.bs.modal', '.modal', onModalShow);
  $(document).on('hidden.bs.modal', '.modal', onModalHidden);
})();
